import { render, staticRenderFns } from "./UserDetailAsync.vue?vue&type=template&id=09bbd2ab&"
import script from "./UserDetailAsync.vue?vue&type=script&lang=js&"
export * from "./UserDetailAsync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports